import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { selectCountry } from "../../../../../store/HOC/genericUI.selectors";
import {
  selectOwnerContactPersonFormData,
  selectShouldDisplayContactPersonTypeForm,
  selectShouldDisplayContactPersonDetailsForm,
  selectUIData,
} from "../owner.selectors";
import { setContactPersonType, setUIObjectField } from "../owner.slice";

import { ComponentId } from "./enums";

export const main: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.OWNER_CONTACT_PERSON_DATA,
  id: [FormId.OWNER_CONTACT_PERSON_DATA, "main"].join("-"),
  selector: selectOwnerContactPersonFormData,
  isVisible: selectShouldDisplayContactPersonTypeForm,
  content: [
    {
      sections: [
        {
          id: "contact-person-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.TYPE,
              onChange: setContactPersonType,
              label:
                "Kto jest osobą kontaktową do czynności związanych z likwidacją szkody?",
              required: true,
              items: [
                {
                  label: "Właściciel mienia",
                  value: "owner",
                },
                {
                  label: "Inna osoba",
                  value: "otherPerson",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const formDetails: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.OWNER_CONTACT_PERSON_DATA,
  id: [FormId.OWNER_CONTACT_PERSON_DATA, "details"].join("-"),
  selector: selectOwnerContactPersonFormData,
  isVisible: selectShouldDisplayContactPersonDetailsForm,
  content: [
    {
      title: "Dane innej osoby kontaktowej",
      sections: [
        {
          id: "contact-person-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.NAME,
              label: "Imię",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.SURNAME,
              label: "Nazwisko",
              required: true,
            },
          ],
        },
        {
          id: "contact-person-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.COMPANY_NAME,
              label: "Nazwa firmy",
            },
          ],
        },
        {
          id: "contact-person-data-4",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)("contactPersonphone"),
              id: ComponentId.PHONE,
              onChange: setUIObjectField,
              label: "Telefon",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.EMAIL,
              label: "Email",
              required: true,
            },
          ],
        },
      ],
    },
  ],
};
